module.exports = __webpack_public_path__ + "static/media/cheshire.0875600b.jpg";